<template>
  <div
    v-loading="loading"
    element-loading-text="Loading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.3)"
    v-loading.fullscreen.lock="fullscreenLoading">
    <h2 class="person-title">{{this.$t('userInfo.Personal')}}</h2>
    <el-form ref="userForm" :model="userForm" label-width="100px">
      <el-form-item :label="$t('userInfo.avatar')" >
        <el-upload
          class="avatar-uploader"
          action="http://hdd.mrtlab.com:8080/api/file/uploads"
          :headers="header"
          name="files"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="avatar" :src="avatar" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item :label="$t('userInfo.username')">
        <el-input v-model="userForm.username" disabled style="width:350px"></el-input>
      </el-form-item>
      <el-form-item :label="$t('userInfo.Nickname')">
        <el-input v-model="userForm.nickname" style="width:350px"></el-input>
      </el-form-item>
      <el-form-item :label="$t('userInfo.Tel')">
        <el-input v-model="userForm.phone" style="width:350px"></el-input>
      </el-form-item>
      <el-form-item :label="$t('userInfo.QQ')">
        <el-input v-model="userForm.qq" style="width:350px"></el-input>
      </el-form-item>
      <el-form-item :label="$t('userInfo.Email')">
        <el-input v-model="userForm.email" style="width:350px"></el-input>
      </el-form-item>
      <el-form-item  :label="$t('userInfo.Balance')" >
        <el-form-item class="price-tag">
          <!-- <span>{{userForm.usd}}{{this.$t('common.USD')}}</span> -->
          <!-- <span>{{userForm.rmb}}{{this.$t('common.RMB')}}</span> -->
          <span>{{userForm.gold}}{{this.$t('common.Coins')}}</span>
          <!-- <span @click="Withdraw">{{this.$t('common.Withdraw')}}</span> -->
        </el-form-item>
      </el-form-item>
      <el-form-item :label="this.$t('userInfo.Address')" >
        <el-col :span="4">
          <el-input :placeholder="$t('userInfo.Country')" v-model="userForm.country" style="width: 100%;"></el-input>
        </el-col>
        <el-col class="line" :span="1">-</el-col>
        <el-col :span="4">
          <el-input :placeholder="$t('userInfo.Province')"  v-model="userForm.province" style="width: 100%;"></el-input>
        </el-col>
        <el-col class="line" :span="1">-</el-col>
        <el-col :span="4">
          <el-input :placeholder="$t('userInfo.City')" v-model="userForm.city" style="width: 100%;"></el-input>
        </el-col>
        <el-col class="line" :span="1"></el-col>
      </el-form-item>
      <el-form-item  :label="$t('userInfo.longAddress')">
        <el-input v-model="userForm.address"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="onSubmit">{{this.$t('userInfo.modification')}}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import axios from '@/axios'

  export default {
    name: "personFile",
    data() {
      return {
        loading: true,
        fullscreenLoading: true,
        avatar: '',
        dialogVisible: false,
        header: {
          token: ''
        },
        userForm: {
          username: '',
          nickname: '',
          address: '',
          phone: '',
          qq: '',
          mail: '',
          // rmb: '0',
          // usd: '0',
          gold: '0',
          country: '',
          province: '',
          city: '',
        }
      }
    },
    created: function () {
      this.getUserInfu();
    },

    methods: {
      //初始化页面 获取用户数据
      getUserInfu() {
        let _this = this;
        var token = localStorage.getItem('loginToken');
        this.header.token = token;
        axios.get(this.$store.state.apiBasePath + "/user/info")
          .then(function (res) {
            var resData = res.data;
            if (resData.code === 200) {
              _this.loading=false;
              _this.fullscreenLoading=false;
              _this.userForm = resData.data;
              _this.avatar=resData.data.image;
              if(_this.avatar==undefined || _this.avatar =="" || _this.avatar==null){
                  _this.avatar="/static/avatar.jpg"
              }
            } else {
              _this.$message({
                type: 'error',
                title:_this.$t('message.Error'),
                message:res.data.msg,
                showClose: true,
                offset:300,
                duration:3000,
              });
            }
          })
      },

      //提现功能 - 已注释掉
      // Withdraw(){
      //   this.$message({
      //     type: 'error',
      //     title:this.$t('message.Prompt'),
      //     message:this.$t('message.Withdraw'),
      //     showClose: true,
      //     offset:300,
      //     duration:3000,
      //   });
      // },
      //提交修改资料
      onSubmit() {
        let _this = this;
        // console.log(this.avatar);
        axios.post(this.$store.state.apiBasePath + "/user/update", {
          "address": _this.userForm.address,
          "city": _this.userForm.city,
          "country": _this.userForm.country,
          "email": _this.userForm.email,
          "image": this.avatar,
          "nickname": _this.userForm.nickname,
          "phone": _this.userForm.phone,
          "province": _this.userForm.province,
          "qq": _this.userForm.qq
        })
          .then(function (res) {
            var resData = res.data;
            if (resData.code === 200) {
              _this.userForm = resData.data;
              localStorage.setItem('nickname',_this.userForm.nickname);
              _this.$message({
                type: 'success',
                title: _this.$t('message.Success'),
                message:_this.$t('userInfo.Modify'),
                showClose: true,
                offset:300,
                duration:3000,
                onClose: function () {
                  // 修改用户资料，刷新页面
                  window.location.reload()
                }
              });
            } else {
              _this.$message({
                type: 'error',
                title: _this.$t('message.Error'),
                message:res.data.msg,
                showClose: true,
                offset:300,
                duration:3000,
              });
            }
          })
      },

      //头像上传成功
      handleAvatarSuccess(res, file) {
        this.avatar = res.data[0].url;
        // console.log(this.avatar);
      },
      //头像上传验证
      beforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error(this.$t('userInfo.avatarJpg'));
        }
        if (!isLt2M) {
          this.$message.error(this.$t('userInfo.avatarSize'));
        }
        return isJPG && isLt2M;
      }
    }

  }
</script>

<style scoped>
  .person-title {
    border-bottom: #ddd 1px solid;
    padding-bottom: 10px;
    color: #000;
  }
  .line {
    text-align: center;
  }
  .price {
    text-align: left;
    padding-left: 10px;
  }

  .price-tag span {
    margin-right: 25px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius:50%;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: #ddd 1px solid;
    border-radius: 5px;
  }
  .avatar-uploader-icon:hover {
    cursor: pointer;
    border: #409EFF dashed 1px;
  }
  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    -webkit-border-radius: 50%;
    -moz-border-radius:50%;
    border-radius:50%;
  }

</style>



// WEBPACK FOOTER //
// src/components/userCenter/personFile.vue